module.exports = __webpack_public_path__ + "f0bf3b5e900cc735de28632ed60555da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/trumpet-button-pressed-background.png
// module id = 126
// module chunks = 0